import script from "./navTitle.vue?vue&type=script&setup=true&lang=js"
export * from "./navTitle.vue?vue&type=script&setup=true&lang=js"

import "./navTitle.vue?vue&type=style&index=0&id=84c49edc&lang=less&scoped=true"

import exportComponent from "G:\\project\\csadmin-master\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-84c49edc"]])

export default __exports__